import type { GrammarExercise } from '../exercise-types';
import { foundationsExercises } from './foundations';
import { everydayExercises } from './everyday';
import { modalsExercises } from './modals';
import { advancedTensesExercises } from './advanced-tenses';
import { connectingExercises } from './connecting';
import { fluencyExercises } from './fluency';

// Practice exercises for every Grammar Aid topic, keyed by topic slug.
// One file per curriculum group, merged here for the topic page.
export const GRAMMAR_EXERCISES: Record<string, GrammarExercise[]> = {
  ...foundationsExercises,
  ...everydayExercises,
  ...modalsExercises,
  ...advancedTensesExercises,
  ...connectingExercises,
  ...fluencyExercises,
};

export type { GrammarExercise } from '../exercise-types';
